import { render } from "./PaymentPositionToClient.vue?vue&type=template&id=68750369&scoped=true"
import script from "./PaymentPositionToClient.vue?vue&type=script&lang=js"
export * from "./PaymentPositionToClient.vue?vue&type=script&lang=js"

import "./PaymentPositionToClient.vue?vue&type=style&index=0&id=68750369&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68750369"]])

export default __exports__